import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Approval } from 'src/app/models/approval.model';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'que-approvals-menu-item',
    imports: [CommonModule, OverlayModule, TranslateDirective, TranslatePipe, SvgIconComponent],
    templateUrl: './approvals-menu-item.component.html',
    styleUrls: ['./approvals-menu-item.component.scss']
})
export class ApprovalsMenuItemComponent {
  @Input() approval?: Approval;
  @ViewChild('trigger') trigger!: ElementRef;
  #router = inject(Router);

  isMenuOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  openMenu($event: Event) {
    $event.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (triggerRect.bottom + 200 > viewportHeight) {
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
    this.isMenuOpen = true
  }

  viewRequest(event?: Event) {
    event?.stopPropagation();
    if (this.approval?.recipientGuid) {
      this.#router.navigate(['viewAnswers', this.approval.recipientGuid, this.approval.status]);
    }
  }
}
